import React from "react";
import {
  Box,
  useTheme,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import Header from "../../components/Header";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { tokens } from "../../theme";

const Index = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m="20px" sx={{ marginTop: "100px" }}>
      <Header title="FAQ" subtitle="Frequently Asked Questions Page" />

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            An Important question
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Illo earum
            aliquam impedit iusto dignissimos iure, explicabo inventore
            adipisci? A maxime iusto ratione omnis quo? Voluptatum molestias
            dolore delectus. Vel, labore!
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            Another Important question
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Illo earum
            aliquam impedit iusto dignissimos iure, explicabo inventore
            adipisci? A maxime iusto ratione omnis quo? Voluptatum molestias
            dolore delectus. Vel, labore!
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            some question
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Illo earum
            aliquam impedit iusto dignissimos iure, explicabo inventore
            adipisci? A maxime iusto ratione omnis quo? Voluptatum molestias
            dolore delectus. Vel, labore!
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            Fav question
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Illo earum
            aliquam impedit iusto dignissimos iure, explicabo inventore
            adipisci? A maxime iusto ratione omnis quo? Voluptatum molestias
            dolore delectus. Vel, labore!
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            Some random question
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Illo earum
            aliquam impedit iusto dignissimos iure, explicabo inventore
            adipisci? A maxime iusto ratione omnis quo? Voluptatum molestias
            dolore delectus. Vel, labore!
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default Index;
